import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const duplicate = async (boardId, payload) => {
  const user = firebase.auth().currentUser
  if (!user) return null
  const userAuthToken = await user.getIdToken()

  const { data: response } = await AxiosConfig.post(`/boards/duplicate/${boardId}`, payload, {
    headers: {
      Authorization: `Bearer ${userAuthToken}`
    }
  })
  return response.data
}

export default {
  duplicate
}